import { render, staticRenderFns } from "./RecordedSmallCard.vue?vue&type=template&id=b133d310&scoped=true&"
import script from "./RecordedSmallCard.vue?vue&type=script&lang=ts&"
export * from "./RecordedSmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedSmallCard.vue?vue&type=style&index=0&id=b133d310&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b133d310",
  null
  
)

export default component.exports